<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<epg-frame
  [user]="userData"
  [useTenants]="false"
  [activeTenant]="activeTenantDto"
  (activeTenantChangedEvent)="onActiveTenantChanged($event)"
  (logoutEvent)="logout($event)"
  [useSidebar]="!router.url.includes('/designer/')"
  [dir]="'ltr'"
  [showMenuIcons]="true"
  [hasHelp]="true"
>
  <app-help-and-documentation epg-menu-content-help></app-help-and-documentation>
</epg-frame>

<ng-template #unauthorizedTenantTemplate>
  <div [innerHTML]="unauthorizedTenantMessage"></div>
</ng-template>
